import './spotlight-slider.scss';

import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { Responsive } from '../utils';

const COMPONENT_NAME = 'spotlight-slider';
const BEM = {
  BLOCK: COMPONENT_NAME,
  SPOTLIGHT_SLIDER: 'spotlight-slider__slider',
  ELEMENT_SLIDER_ITEM: 'spotlight-slider__slider__item',
  SLIDER_NAV: 'spotlight-slider__slider-nav',
  ELEMENT_FOOT: 'spotlight-slider__foot',
};

export class SpotlightSlider {
  constructor($container = $('body')) {
    const self = this;

    this._els = {};
    this._els.container = $container;
    this._els.spotlightSection = this._els.container.find(`.${BEM.BLOCK}`);

    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.spotlightSection.each(function () {
        self._initSingleInstance($(this));
      });
    });
  }

  // private methods
  _initSingleInstance($instanceEl) {
    const self = this;
    self._initSlider($instanceEl);
  }

  // init (or reinit if already initialized) the slider in case the instance contains more than one slide
  _initSlider($instanceEl) {
    const self = this;
    const $sliderItems = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);
    const hasPreview = $instanceEl.hasClass('spotlight-slider--preview');
    const isMultipleSlide = $instanceEl.hasClass('spotlight-slider--multiple-slide');

    if ($sliderItems.length > 1) {
      const $slider = $instanceEl.find(`.${BEM.SPOTLIGHT_SLIDER}`);
      $slider.filter('.slick-initialized').slick('unslick');

      const baseConfig = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        prevArrow: hasPreview ? '' : '<div role="img" class="svg-icon icon-arrow-left-grey preview-arrow-left"><use xlink:href="#sprite-arrow-left-blue"></use></div>',
        nextArrow: hasPreview ? '' : '<div role="img" class="svg-icon icon-arrow-right-grey preview-arrow-right"><use xlink:href="#sprite-arrow-left-blue"></use></div>',
        asNavFor: hasPreview ? $instanceEl.find(`.${BEM.SLIDER_NAV}`) : '',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              dots: true,
            },
          },
        ],
      };

      if (isMultipleSlide) {
        baseConfig.slidesToShow = 3;
        baseConfig.arrows = true;
        baseConfig.dots = true;
        baseConfig.responsive = [
          {
            breakpoint: 1400,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '100px',
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '50px',
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '30px',
            },
          },
        ];
      }

      $slider.slick(baseConfig);

      if (hasPreview) {
        $instanceEl.find(`.${BEM.SLIDER_NAV}`).slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          asNavFor: $slider,
          focusOnSelect: true,
          arrows: true,
          prevArrow: '<svg role="img" class="svg-icon svg-icon--arrow-left-blue preview-arrow-left"><use xlink:href="#sprite-arrow-left-blue"></use></svg>',
          nextArrow: '<svg role="img" class="svg-icon svg-icon--arrow-left-blue preview-arrow-right"><use xlink:href="#sprite-arrow-left-blue"></use></svg>',
        });
      }

      $slider.on('afterChange', (event, slick, currentSlide) => {
        $instanceEl.find('.spotlight-slider__info__slide--active').removeClass('spotlight-slider__info__slide--active');
        $instanceEl.find(`.spotlight-slider__info__slide:eq(${currentSlide})`).addClass('spotlight-slider__info__slide--active');
      });
    }

    if (Responsive.getCurrentBreakpointName() === 'sm' || Responsive.getCurrentBreakpointName() === 'xs') {
      $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`).each(function () {
        const $slide = $(this);
        self._initSlideAnchorOverlay($slide);
      });
    }
  }

  _initSlideAnchorOverlay($slide) {
    const $cta = $slide.find(`.${BEM.ELEMENT_FOOT} .btn`);
    if ($cta.length === 1) {
      const $anchorOverlay = $cta.clone(true);
      $anchorOverlay.addClass('tcl-banner__anchor-overlay');
      $anchorOverlay.hover(() => $cta.addClass('active'), () => $cta.removeClass('active'));
      $slide.append($anchorOverlay);
    }
  }
}
